<template>
  <tasting-transition v-if="type === 'tastingTransition'" @next="next" />
  <tasting-question v-else @next="next" />
</template>

<script>
import { mapGetters } from 'vuex'

import { NEXT_TASTING_STEP } from '@/store/modules/tasting/types'
import TastingQuestion from '@/components/tasting/steps/TastingQuestion'
import TastingTransition from '@/components/tasting/steps/TastingTransition'

export default {
  name: 'TastingStep',
  components: { TastingTransition, TastingQuestion },
  computed: {
    ...mapGetters({
      type: 'currentStepType'
    })
  },
  methods: {
    next() {
      this.$store.dispatch(NEXT_TASTING_STEP)
    }
  }
}
</script>
